import React from "react";

const ValueTag = (props) => {
  const { type, inventory, stock, inventoryNumber } = props;

  return (
    <div>
      {type ? (
        <div className="inline-flex items-center">
          <span>{inventory}</span>
          <span
            className={
              inventoryNumber == 0
                ? "ml-2 bg-red-200 text-red-800 text-xs text-medium rounded-lg py-1 px-2"
                : inventoryNumber <= stock
                  ? "ml-2 bg-orange-200 text-orange-800 text-xs text-medium rounded-lg py-1 px-5"
                  : "ml-2 bg-green-200 text-green-800 text-xs text-medium rounded-lg py-1 px-2"
            }
          >
            {inventoryNumber == 0
              ? "Out Of Stock"
              : inventoryNumber <= stock
                ? "Low"
                : "Stocked"}
          </span>
        </div>
      ) : (
        <div>
          <span
            className={
              "ml-2 bg-cyan-200 text-cyan-800 text-xs text-medium rounded-lg py-1 px-2"
            }
          >
            Nonstockable
          </span>
        </div>
      )}
    </div>
  );
};

export default ValueTag;
